module.exports = __webpack_public_path__ + "img/icon16.e5c0e04f.svg";